import { Component, ViewEncapsulation } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { CmsComponentData } from '@spartacus/storefront';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-cms-image',
  templateUrl: './cms-image.component.html',
  styleUrls: ['./cms-image.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class CmsImageComponent {
  mediaUrl$: Observable<any> = this.component.data$.pipe(map((data) => data.media.url));
  baseUrl = this.meta.getTag('name=occ-backend-base-url').content;

  constructor(private component: CmsComponentData<any>, private meta: Meta) {}

  setMediaUrl(media: string): any {
    return this.baseUrl + media;
  }
}
